<template>
  <h3>Unsere Partner</h3>
  <div class="partner-banner">
    <div class="logo-container" v-for="partner in partners" :key="partner.name">
      <img :src="partner.logo" :alt="partner.name" class="partner-logo" />
    </div>
    <div class="logo-container sponsor">
      <a href="#" class="sponsor-link">Become a Partner</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partners: [
        {
          name: "Google",
          logo: "https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg",
        },
        {
          name: "Anwalt-de",
          logo: "https://mkg-online.de/wp-content/uploads/2023/07/anwalt-de-Logo-1000px_WEB.png",
        },
        {
          name: "Cloudflare",
          logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Cloudflare_Logo.svg/768px-Cloudflare_Logo.svg.png?20220519022010",
        },
        {
          name: "Kanzlei",
          logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Die_Kanzlei_Logo.svg/1143px-Die_Kanzlei_Logo.svg.png",
        },
        {
          name: "OpenAI",
          logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/OpenAI_Logo.svg/768px-OpenAI_Logo.svg.png?20230731013808",
        },
      ],
    };
  },
};
</script>

<style scoped>
h3 {
  font-size: 28px;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

/* Modernes Grid-Layout */
.partner-banner {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 30px;
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Style für einzelne Boxen */
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  background-color: #fafafa;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.partner-logo {
  max-height: 80px;
  max-width: 130px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

/* Modernes Styling für das Sponsoren-Feld */
.sponsor {
  border: 2px dashed #333;
}

.sponsor-link {
  text-decoration: none;
  color: #333;
  font-weight: bold;
  font-size: 18px;
  transition: color 0.3s ease;
}

.sponsor-link:hover {
  color: #444;
}
</style>
